// extracted by mini-css-extract-plugin
module.exports = {"gridArea":"elderMngt_gridArea__1dKCK"};